module.exports = __webpack_public_path__ + "img/title-shiba.934eb9a7.png";